import React from 'react';
import AvailabilitySection from './AvailabilitySection';
import ContactsCard from './ContactsCard';
export default function LineMedicSections({data}){
  return <>
    <AvailabilitySection title="EMPF / EMTF Available for Deployment" subtitle="Available Line Medics — qualified to fill either EMPF or EMTF orders" people={data.medicsAvailable}/>
    <AvailabilitySection title="EMTF Available for Deployment" subtitle="Dedicated EMTF personnel currently marked available" people={data.emtsAvailable}/>
    <AvailabilitySection title="Currently Deployed" subtitle="Line Medic, Strike Team, or Other Assignment" people={data.deployed} deployed/>
    <ContactsCard contacts={data.contacts}/>
  </>;
}
